













    import { CONFIG } from '@/config';
import {Component, Vue} from 'vue-property-decorator';

    @Component({
        name: 'NavBar'
    })
    export default class NavBar extends Vue {
        public openNeogig(): void {
            window.location.assign(`${CONFIG.URL.NEOGIG}`);
        }
    }
